

// Haeufige Vertipper bei den grossen Anbietern. Dieselbe Liste steht im Worker
// (/mail/pruefen); hier dient sie nur dazu, den Hinweis sofort zu zeigen, ohne
// auf den Server zu warten. Der Server bleibt die massgebliche Pruefung.
const SUS_TIPPFEHLER = {
  'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmail.de': 'gmail.com',
  'gmaill.com': 'gmail.com', 'gmil.com': 'gmail.com', 'gamil.com': 'gmail.com',
  'gmail.co': 'gmail.com', 'googlemail.de': 'googlemail.com',
  'web.e': 'web.de', 'wen.de': 'web.de', 'wb.de': 'web.de', 'web.d': 'web.de',
  'gmx.e': 'gmx.de', 'gmx.d': 'gmx.de', 'gnx.de': 'gmx.de',
  'hotmai.com': 'hotmail.com', 'hotmial.com': 'hotmail.com', 'hotmail.de': 'hotmail.com',
  'outlok.com': 'outlook.com', 'outllok.com': 'outlook.com',
  'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com',
  't-onlne.de': 't-online.de', 't-online.com': 't-online.de',
  'freent.de': 'freenet.de', 'arcor.com': 'arcor.de',
};
// Bewusst streng: mindestens ein Punkt nach dem @ und zwei Buchstaben am Ende.
// "name@gmail" oder "a@b" kommen damit gar nicht erst bis zum Server.
const SUS_MAIL_FORM = /^[^@\s]+@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i;

function susMailBrauchbar(wert) {
  return SUS_MAIL_FORM.test(String(wert || '').trim());
}

function susMailVorschlag(wert) {
  const teile = String(wert || '').trim().toLowerCase().split('@');
  if (teile.length !== 2) return null;
  const ziel = SUS_TIPPFEHLER[teile[1]];
  return ziel ? teile[0] + '@' + ziel : null;
}

/*
  Stoff und Stahl — „Kostenlos testen" auf der Produktseite (Phase 2).

  Dieser Block rechnet nichts selbst. Er liest den Personalisierungsblock —
  dieselben drei Fotos, die auch in den Warenkorb gingen, bereits umgewandelt
  und geprueft — meldet die Vorschau an, laedt die Fotos hoch und schickt den
  Besucher auf /pages/vorschau?v=…, wo das Ergebnis samt Groessenwahl und
  Kaufknopf ohnehin schon steht. Zwei Oberflaechen fuer dasselbe Ergebnis
  haette niemand pflegen wollen.

  WICHTIG: Am Personalisierungsblock wird nichts geschrieben. Er wird nur
  gelesen (geprueft, modellSelect, textarea, form) und beobachtet. Seine Sperre
  des Kaufknopfs und der Schutz gegen den Doppelversand vom 27.09.2026 bleiben
  damit unberuehrt.
*/
(() => {
  const wurzel = document.querySelector('[data-sus-test]');
  if (!wurzel) return;

  const block = document.querySelector('stoffundstahl-personalisierung');
  if (!block) return;

  const BASIS = (wurzel.dataset.basis || '').replace(/\/$/, '');
  const PRODUKTART = wurzel.dataset.produktart || 'hoodie';
  const ZIEL = wurzel.dataset.ziel || '/pages/vorschau';
  const ANSICHTEN = ['front', 'seite', 'heck'];
  const NAMEN = { front: 'von vorn', seite: 'von der Seite', heck: 'von hinten' };

  const lese = (name, rueckfall) => {
    const el = wurzel.querySelector(`[data-sus-test-${name}]`);
    if (!el) return rueckfall;
    try { return JSON.parse(el.textContent); } catch (e) { return rueckfall; }
  };
  const VARIANTEN = lese('varianten', {});
  const FARBLISTE = lese('farbliste', '');

  const HEX = {};
  String(FARBLISTE || '').split(/\r?\n/).forEach((zeile) => {
    const m = zeile.match(/^\s*(.+?)\s*=\s*(#[0-9A-Fa-f]{6})\s*$/);
    if (m) HEX[m[1].toLowerCase()] = m[2].toUpperCase();
  });

  const kasten = wurzel.querySelector('[data-sus-test-kasten]');
  const bereitFeld = wurzel.querySelector('[data-sus-test-bereit]');
  const mailFeld = wurzel.querySelector('[data-sus-test-mail]');
  const mailTipp = wurzel.querySelector('[data-sus-test-mailtipp]');
  const knopf = wurzel.querySelector('[data-sus-test-start]');
  const fehlerFeld = wurzel.querySelector('[data-sus-test-fehler]');

  // Der Knopf bleibt gesperrt, bis die Adresse brauchbar aussieht (26.10.2026).
  // Sie ist Pflicht und der einzige Weg zur Vorschau; ein Klick ohne sie wuerde
  // nur eine Absage vom Server einhandeln. Bei einem erkannten Vertipper in der
  // Domain steht darueber ein Vorschlag, den ein Klick uebernimmt.
  function tkMailWache() {
    const wert = mailFeld ? mailFeld.value : '';
    const gut = susMailBrauchbar(wert);
    if (knopf) knopf.disabled = !gut;

    const ziel = susMailVorschlag(wert);
    if (!mailTipp) return;
    if (ziel) {
      mailTipp.textContent = 'Meintest du ';
      const a = document.createElement('button');
      a.type = 'button';
      a.className = 'sus-vs__tippknopf';
      a.textContent = ziel.split('@')[1] + '?';
      a.addEventListener('click', () => {
        mailFeld.value = ziel;
        mailTipp.hidden = true;
        tkMailWache();
        mailFeld.focus();
      });
      mailTipp.appendChild(a);
      mailTipp.hidden = false;
    } else {
      mailTipp.textContent = '';
      mailTipp.hidden = true;
    }
  }
  if (mailFeld) {
    mailFeld.addEventListener('input', tkMailWache);
    mailFeld.addEventListener('blur', tkMailWache);
    tkMailWache();
  }

  const zeige = (el, an) => { if (el) el.hidden = !an; };
  const fehler = (text) => {
    fehlerFeld.textContent = text || '';
    zeige(fehlerFeld, !!text);
  };

  /* ------------------------------------------------- Zustand des Nachbarn */

  // Farbe der gerade gewaehlten Variante: „L / Deep Black" -> „Deep Black"
  const farbeJetzt = () => {
    const feld = block.form && block.form.querySelector('[name="id"]');
    const titel = feld ? VARIANTEN[String(feld.value)] : null;
    const name = titel ? String(titel).split('/').pop().trim() : '';
    return name ? { name, hex: HEX[name.toLowerCase()] || '#888888' } : null;
  };

  const fotosFertig = () => {
    const g = block.geprueft || {};
    return ANSICHTEN.every((a) => g[a] && g[a].file);
  };

  // Ein Folgeartikel traegt die Fotos aus dem Warenkorb, hier liegt dann nichts
  // Umgewandeltes. Fuer den gibt es nichts zu testen — der Kasten bleibt weg.
  const folgeartikel = () => !!block.vorhandenImWarenkorb && !block.aendernAktiv;

  let bereit = false;
  const zustandPruefen = () => {
    if (folgeartikel()) {
      zeige(wurzel, false);
      return;
    }
    zeige(wurzel, true);
    const jetzt = fotosFertig();
    if (jetzt === bereit) return;          // nur bei Wechsel anfassen
    bereit = jetzt;
    zeige(kasten, !jetzt);
    zeige(bereitFeld, jetzt);
  };

  new MutationObserver(zustandPruefen).observe(block, {
    subtree: true, childList: true, characterData: true, attributes: true,
  });
  block.addEventListener('change', zustandPruefen);
  document.addEventListener('shopify:cart:lines-update', zustandPruefen);
  zustandPruefen();

  /* ------------------------------------------------------------- Einstieg */

  if (kasten) {
    kasten.addEventListener('click', () => {
      const ziel = block.querySelector('[data-sus-foto]') || block;
      ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const erstes = block.querySelector('[data-sus-datei]');
      if (erstes) erstes.focus({ preventScroll: true });
    });
  }

  const melden = (kennung, ereignis) => {
    // Automatische Laeufe zaehlen nicht mit, siehe utm_source=test in Teil 5.
    if (/[?&]utm_source=test(&|$)/.test(location.search)) return;
    try {
      // Als Abfrageparameter, ohne Rumpf: ein Beacon mit application/json loest
      // eine CORS-Vorabanfrage aus, die er nicht fuehren kann — der Browser wirft
      // ihn dann weg, ohne dass es jemand merkt (19.10.2026).
      const ziel = `${BASIS}/webhook/vorschau/ereignis`
        + `?ereignis=${encodeURIComponent(ereignis)}`
        + (kennung ? `&kennung=${encodeURIComponent(kennung)}` : '');
      navigator.sendBeacon
        ? navigator.sendBeacon(ziel)
        : fetch(ziel, { method: 'POST', keepalive: true });
    } catch (e) { /* Messung darf den Weg nie aufhalten */ }
  };

  // Nur hinsehen, nichts heilen (20.10.2026). Naeheres in
  // stoffundstahl-panne.js; hier wird nur der Einstieg mitgegeben.
  let kennungJetzt = '';
  const panne = (schritt, fehler, zusatz) => {
    if (window.susPanne) {
      window.susPanne(BASIS, schritt, fehler,
        { ...(zusatz || {}), quelle: 'produktseite', kennung: kennungJetzt });
    }
  };
  const merken = (e) => { try { e.sus_gemeldet = true; } catch (x) { /* egal */ } return e; };

  const hol = async (pfad, daten) => {
    const antwort = await fetch(`${BASIS}${pfad}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(daten),
    });
    return antwort.json();
  };

  const fotoBytes = () => {
    try {
      return ANSICHTEN.reduce((s, a) => s + ((block.geprueft[a] || {}).file || {}).size, 0);
    } catch (e) { return null; }
  };

  const starten = async () => {
    fehler('');
    if (!fotosFertig()) return fehler('Es fehlen noch Fotos.');
    if (!block.modellSelect || !block.modellSelect.value) return fehler('Bitte wähle dein Modell.');
    const mail = (mailFeld.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mail)) {
      return fehler('Bitte gib eine Mailadresse an, an die wir die Vorschau schicken dürfen.');
    }
    const farbe = farbeJetzt();
    if (!farbe) return fehler('Bitte wähle erst eine Farbe.');

    const grund = knopf.textContent;
    knopf.disabled = true;
    knopf.textContent = 'Deine Fotos gehen raus …';
    melden(null, 'test_gestartet');

    try {
      const an = await hol('/webhook/vorschau/anmelden', {
        mail,
        modell: block.modellSelect.value,
        produktart: PRODUKTART,
        farbe_name: farbe.name,
        farbe_hex: farbe.hex,
        infotext: block.textarea ? block.textarea.value : '',
        min_kante: block.minKante,
        quelle: 'produktseite',
      });
      if (!an.ok) {
        panne('anmelden_abgelehnt', an.text || 'ohne Grund', {});
        throw merken(new Error(an.text || 'Das hat gerade nicht geklappt.'));
      }
      kennungJetzt = an.kennung || '';

      const paket = new FormData();
      paket.append('kennung', an.kennung);
      paket.append('ablauf', an.ablauf);
      paket.append('ticket', an.ticket);
      paket.append('min_kante', String(an.min_kante || block.minKante));
      ANSICHTEN.forEach((a) => paket.append(a, block.geprueft[a].file));

      let hoch;
      try {
        hoch = await (await fetch(an.upload_url, { method: 'POST', body: paket })).json();
      } catch (e) {
        panne('upload', e, { bytes: fotoBytes(), format: 'image/jpeg' });
        throw merken(e);
      }
      if (hoch.zu_klein && hoch.zu_klein.length) {
        panne('upload_zu_klein', hoch.zu_klein.join(','), { bytes: fotoBytes() });
        throw merken(new Error('Diese Fotos sind zu klein: '
          + hoch.zu_klein.map((a) => NAMEN[a] || a).join(', ') + '.'));
      }
      melden(an.kennung, 'fotos_hochgeladen');

      await hol('/webhook/vorschau/los', { kennung: an.kennung });
      // neu=1: auf der Vorschau-Seite ist das die erste Anzeige, nicht die
      // Rueckkehr ueber den Kauf-Link — nur so stimmt die Wochentabelle.
      location.href = `${ZIEL}?v=${encodeURIComponent(an.kennung)}&neu=1`;
    } catch (e) {
      if (!(e && e.sus_gemeldet)) panne('start', e, { bytes: fotoBytes() });
      fehler(e.message || 'Das hat gerade nicht geklappt.');
      knopf.disabled = false;
      knopf.textContent = grund;
    }
  };

  if (knopf) knopf.addEventListener('click', starten);
})();
